import { FC, PropsWithChildren, useCallback, useState } from 'react';
import { Flex, FlexProps, Radio } from 'antd';
import { RadioChangeEvent } from 'antd/es/radio/interface';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import styled from 'styled-components';
import translations from './AlgorithmTableViewRadio.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-table-view-radio'
);
addTranslations(translations);

export interface AlgorithmTableViewRadioProps extends Partial<FlexProps> {
  onChangeView?: (isAlgorithmView: boolean, isSummaryView: boolean) => void;
}

export const AlgorithmTableViewRadio: FC<
  PropsWithChildren<AlgorithmTableViewRadioProps>
> = (props) => {
  const { onChangeView, ...rest } = props;
  const { t } = useTranslation();

  const [isAlgorithmView, setIsAlgorithmView] = useState(true);
  const [isSummaryView, setIsSummaryView] = useState(true);

  const onAlgorithmViewChange = useCallback(
    (e: RadioChangeEvent) => {
      setIsAlgorithmView(e.target.value);
      onChangeView?.(e.target.value, isSummaryView);
    },
    [setIsAlgorithmView, isSummaryView, onChangeView]
  );

  const onSummaryViewChange = useCallback(
    (e: RadioChangeEvent) => {
      setIsSummaryView(e.target.value);
      onChangeView?.(isAlgorithmView, e.target.value);
    },
    [setIsSummaryView, isAlgorithmView, onChangeView]
  );

  return (
    <Flex gap="middle" {...rest}>
      <StyledRadioGroup
        onChange={onAlgorithmViewChange}
        value={isAlgorithmView}
      >
        <Radio.Button value={true}>
          {t('algorithmViewRadio.algorithm')}
        </Radio.Button>
        <Radio.Button value={false}>
          {t('algorithmViewRadio.target')}
        </Radio.Button>
      </StyledRadioGroup>
      <StyledRadioGroup onChange={onSummaryViewChange} value={isSummaryView}>
        <Radio.Button value={true}>
          {t('summaryViewRadio.summary')}
        </Radio.Button>
        <Radio.Button value={false}>{t('summaryViewRadio.full')}</Radio.Button>
      </StyledRadioGroup>
    </Flex>
  );
};

const StyledRadioGroup = styled(Radio.Group)`
  white-space: nowrap;
`;
